<app-menu-overlay></app-menu-overlay>
<app-nav-bar></app-nav-bar>
<div class="app-container top-bar-spacing">
  <router-outlet></router-outlet>
</div>
<local-app-footer class="footer"></local-app-footer>
<app-async-state-overlay [processKeys]="asyncProcessKeys"></app-async-state-overlay>
